import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { dataInsightStoreProperty } from './data-insight.selectors';
import { dataInsightReducer } from './data-insight.reducer';
import {DataInsightEffects} from './data-insight.effects';


@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(dataInsightStoreProperty, dataInsightReducer),
    EffectsModule.forFeature([DataInsightEffects])

  ]
})
export class DataInsightStoreModule { }
